import { defineAsyncComponent } from "vue";
export const Loading = defineAsyncComponent(() =>
  import("./loading/index.vue")
);
